const dataDesc = [
  {
    label: 'Google Analytics',
    data: [
      {
        id: 1,
        link: `https://back.traderiq.net/api/v1/powerbi/google/analytics/stillhalter`,
        desc: `<div class="powerbi-desc">
                    <div class="powerbi-desc-title">Getting page data:</div>
                    <ul>
                        <li>/geheimnisse-stillhalter-live/</li>
                        <li>/geheimnisse-stillhalter-live/danke-stillhalter/</li>
                        <li>/danke-kompass/</li>
                    </ul>
                    <div class="powerbi-desc-title">Parameters:</div>
                    <ul>
                        <li>date - metric date</li>
                        <li>page - target page</li>
                        <li>views - page views</li>
                        <li>users - unique users</li>
                    </ul>
                </div>`,
        resp: `<div>
            <div class="powerbi-desc-title">Response:</div>
            <br/>
            <div class="powerbi-resp">
                <div class="powerbi-resp-format">format: JSON</div>
                <br/>
                <div>{</div>
                    <div class="powerbi-resp-1tab">"status": "success",</div>
                    <div class="powerbi-resp-1tab">"data": [</div>
                        <div class="powerbi-resp-2tab">{</div>
                            <div class="powerbi-resp-3tab">"date": "2025-01-31",</div>
                            <div class="powerbi-resp-3tab">"page": "/geheimnisse-stillhalter-live/",</div>
                            <div class="powerbi-resp-3tab">"views": "1",</div>
                            <div class="powerbi-resp-3tab">"users": "2"</div>
                        <div class="powerbi-resp-2tab">},</div>
                        <div class="powerbi-resp-2tab">{</div>
                            <div class="powerbi-resp-3tab">"date": "2025-01-31",</div>
                            <div class="powerbi-resp-3tab">"page": "/danke-kompass/",</div>
                            <div class="powerbi-resp-3tab">"views": "1",</div>
                            <div class="powerbi-resp-3tab">"users": "2"</div>
                        <div class="powerbi-resp-2tab">},</div>
                        <div class="powerbi-resp-2tab">...</div>
                        <div class="powerbi-resp-3tab">]</div>
                <div>}</div>
            </div>
        </div>`,
      },
    ],
  },
  {
    label: 'Close CRM',
    data: [],
  },
]

export default dataDesc
